import { useLocalization } from "@fluent/react";
import { ContentCard, Checkbox } from "@narmi/design_system";
import { entities } from "byzantine";
import { BulkTemplatePaymentRowType } from "byzantine/src/dbbl/businessLogic/entities/bulkTemplates";
import { useUserFeatures } from "../../../contexts/UserFeaturesContext";
import styles from "../BulkTemplates.module.scss";

const AllowExpediteCard = () => {
  const { l10n } = useLocalization();
  const { expedited_payments: expeditedPaymentsFeature } = useUserFeatures();
  const form = entities.bulkTemplates.BulkTemplateForm.useForm();
  const { allowExpedite, payments } = form.values;

  const hasValidPayment = payments.some((p: BulkTemplatePaymentRowType) =>
    Boolean(p.recipient)
  );

  if (!expeditedPaymentsFeature || !hasValidPayment) {
    return null;
  }

  const handleToggle = () => {
    form.setFieldValue("allowExpedite", !allowExpedite);
  };

  return (
    <div className={`margin--top--l ${styles.allowExpediteCard}`}>
      <ContentCard>
        <Checkbox
          label={l10n.getString(
            "template-allow-expedite-label",
            null,
            "Allow expedited payments"
          )}
          name="allow-expedite"
          checked={Boolean(allowExpedite)}
          onChange={handleToggle}
        />
        <p
          className={`margin--top--xs fontColor--secondary ${styles.allowExpediteDescription}`}
        >
          {l10n.getString(
            "template-allow-expedite-description",
            null,
            "When enabled, users can send instant or same-day ACH payments. Note that instant payments are irrevocable and require an eligible recipient."
          )}
        </p>
      </ContentCard>
    </div>
  );
};

export default AllowExpediteCard;
